module.exports = __webpack_public_path__ + "static/media/main.5ba7d158.png";